export const platformToPlatformName = {
    "healthkart_com": "Healthkart.com",
    "amazon_in": "Amazon",
    "flipkart_com": "Flipkart.com",
    "muscleblaze_com": "Muscleblaze.com",
    "google_play_store": "Google Play Store",
    "apple_app_store": "Apple App Store"
}